import React, { useState, useEffect } from "react";
import Select from "react-select";
import api from "../../api/api";
//import Calibration from "./Calibration";

const Basic = ({ assetId, setAssetId }) => {
  const currentDate = new Date().toISOString().split("T")[0];
  const userName = sessionStorage.getItem("userName");

  // --- Asset Info States ---
  const [assetNo, setAssetNo] = useState("");
  const [assetName, setAssetName] = useState("");
  const [serialNo, setSerialNo] = useState("");
  const [model, setModel] = useState("");
  const [estiRunUnit, setEstiRunUnit] = useState(0);
  const [capacityUnit, setCapacityUnit] = useState("");
  const [specification, setSpecification] = useState("");
  const [manufacturer, setManufacturer] = useState("");
  const [estiLife, setEstiLife] = useState(0);
  const [epcgLicense, setEPCGLicense] = useState("");
  const [acCode, setACCode] = useState("");
  const [originalSize, setOriginalSize] = useState(0);
  const [invoiceNo, setInvoiceNo] = useState("");
  const [Notes, setNotes] = useState("");

  const [invDate, setInvDate] = useState(currentDate);
  const [poNo, setPoNo] = useState("");
  const [poDate, setPoDate] = useState(currentDate);
  const [purchasePrice, setPurchasePrice] = useState(0);
  const [currentValue, setCurrentValue] = useState(0);
  const [isEditLoading, setIsEditLoading] = useState(false);

  // --- Dropdown Options ---
  const [assetData, setAssetData] = useState([]);
  const [supplierOptions, setSupplierOptions] = useState([]);
  const [assetMadeOptions, setAssetMadeOptions] = useState([]);
  const [assetConditionOptions, setAssetConditionOptions] = useState([]);
  const [checkFreqOptions, setCheckFreqOptions] = useState([]);
  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [ownershipOptions, setOwnershipOptions] = useState([]);
  const [ownByOptions, setOwnByOptions] = useState([]);
  const [locationOptions, setLocationOptions] = useState([]);
  const [workCenterOptions, setWorkCenterOptions] = useState([]);
  const [projectNameOptions, setProjectNameOptions] = useState([]); // ✅ New dropdown options

  // --- Selected Dropdown Values ---
  const [selectedAssetType, setSelectedAssetType] = useState(null);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [selectedAssetMade, setSelectedAssetMade] = useState(null);
  const [selectedAssetCondition, setSelectedAssetCondition] = useState(null);
  const [selectedCheckFreq, setSelectedCheckFreq] = useState(null);
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [selectedOwnership, setSelectedOwnership] = useState(null);
  const [selectedOwnBy, setSelectedOwnBy] = useState(null);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [workCenter, setWorkCenter] = useState(null);
  const [currentStatusOptions, setCurrentStatusOptions] = useState([]);
  const [projectName, setProjectName] = useState(null); 

  const [isLocationEditable, setIsLocationEditable] = useState(false);

  const [rating, setRating] = useState(0);
  const [currentStatus, setCurrentStatus] = useState(false);

  useEffect(() => {
    const fetchAssets = async () => {
      try {
        const data = await api.getAssetRegister(userName);

        if (data?.Table)
          setAssetData(data.Table);
        if (data?.Table1)
          setSupplierOptions(data.Table1.map(i => ({ value: i.Vid, label: i.Vname })));
        if (data?.Table2)
          setAssetMadeOptions(data.Table2.map(i => ({ value: i.ImportType, label: i.ImportType })));
        if (data?.Table3)
          setAssetConditionOptions(data.Table3.map(i => ({ value: i.AssetCondition, label: i.AssetCondition })));
        if (data?.Table4)
          setCheckFreqOptions(data.Table4.map(i => ({ value: i.CheckFrequency, label: i.CheckFrequency })));
        if (data?.Table6)
          setDepartmentOptions(data.Table6.map(i => ({ value: i.DeptId, label: i.Department })));
        if (data?.Table12)
          setOwnershipOptions(data.Table12.map(i => ({ value: i.Ownership, label: i.Ownership })));
        if (data?.Table13)
          setOwnByOptions(data.Table13.map(i => ({ value: i.OVid, label: i.OVname })));
        if (data?.Table14)
          setLocationOptions(data.Table14.map(i => ({ value: i.CLVid, label: i.CLVname })));
        if (data?.Table16)
          setWorkCenterOptions(data.Table16.map(i => ({ value: i.WcId, label: i.WorkCenter })));
        if (data?.Table19)
          setCurrentStatusOptions(data.Table19.map(i => ({ value: i.Status, label: i.Status })));

        // ✅ New: Load Project Name dropdown
        if (data?.Table21) {
          setProjectNameOptions(
            data.Table21.map(i => ({
              value: i.PrjId,
              label: `${i.ProjectCode} - ${i.ProjectName}`,
            }))
          );
        }

        const listData = await api.getAssetRegisterList(userName);
        if (listData?.Table) {
          sessionStorage.setItem("assetListForDupCheck", JSON.stringify(listData.Table));
          console.log(
            "✅ AssetNos loaded for duplicate check:",
            listData.Table.map(a => a.AssetNo)
          );
        }
      } catch (err) {
        console.error("Error fetching asset register:", err);
      }
    };
    fetchAssets();
  }, [assetId]);

  useEffect(() => {
    if (isEditLoading) return;

    const fetchOwnByOptions = async () => {
      if (!selectedOwnership || selectedOwnership.value === "Own") {
        setOwnByOptions([]);
        setSelectedOwnBy(null);
        return;
      }

      try {
        const data = await api.getAssetRegister(userName, selectedOwnership.value);
        if (data?.Table13) {
          setOwnByOptions(data.Table13.map(i => ({ value: i.OVid, label: i.OVname })));
        }
      } catch (err) {
        console.error("Error fetching OwnBy options:", err);
      }
    };

    fetchOwnByOptions();
  }, [selectedOwnership, isEditLoading]);

  useEffect(() => {
  if (!assetId) return;

  const fetchEditData = async () => {
    setIsEditLoading(true);
    try {
      const res = await api.EditBasicAssetRegister(assetId);
      if (res && res.Table && res.Table[0]) {
        const data = res.Table[0];

        // Basic Fields
        setAssetNo(data.AssetNo || "");
        setAssetName(data.AssetName || "");
        setSerialNo(data.SerialNo || "");
        setModel(data.Model || "");
        setEstiRunUnit(data.EstRuning_Unit || 0);
        setCapacityUnit(data.Capacity_Unit || "");
        setSpecification(data.Specification || "");
        setManufacturer(data.Manufacture || "");
        setEstiLife(data.EstLIfe || 0);
        setEPCGLicense(data.EPCGLicenseNo || "");
        setACCode(data.AccCode || "");
        setOriginalSize(data.OrginalPrize || 0);
        setInvoiceNo(data.InvNo || "");
        setInvDate(data.InvDate?.split("T")[0] || currentDate);
        setPoNo(data.PoNo || "");
        setPoDate(data.PoDate?.split("T")[0] || currentDate);
        setPurchasePrice(data.PurchasePrize || 0);
        setCurrentValue(data.CurrentValue || 0);
        setRating(data.AssetRating || 0);
        setNotes(data.Notes || "");

        // Dropdowns
        setSelectedSupplier(
          data.SupplierId ? { value: data.SupplierId, label: data.SupplierName } : null
        );
        setSelectedAssetType(
          data.AssetType ? { value: data.AssetType, label: data.AssetType } : null
        );
        setSelectedAssetMade(
          data.AssetMade ? { value: data.AssetMade, label: data.AssetMade } : null
        );
        setSelectedAssetCondition(
          data.AssetCondition ? { value: data.AssetCondition, label: data.AssetCondition } : null
        );
        setSelectedDepartment(
          data.DeptId ? { value: data.DeptId, label: data.Department } : null
        );
        setWorkCenter(
          data.WcId ? { value: data.WcId, label: data.WorkCenter } : null
        );

        setSelectedOwnership(
          data.Ownership ? { value: data.Ownership, label: data.Ownership } : null
        );

        // --- Own By ---
        if (data.Ownership && data.Ownership !== "Own") {
          try {
            const ownByRes = await api.getAssetRegister(userName, data.Ownership);
            if (ownByRes?.Table13) {
              const options = ownByRes.Table13.map(i => ({
                value: i.OVid,
                label: i.OVname,
              }));
              setOwnByOptions(options);
              const selectedOption =
                options.find(opt => opt.value == data.OwnById) ||
                { value: data.OwnById, label: data.OwnBy };
              setSelectedOwnBy(selectedOption);
            }
          } catch (err) {
            console.error("Error fetching OwnBy during edit:", err);
          }
        } else {
          setOwnByOptions([]);
          setSelectedOwnBy(null);
        }

        // --- Current Location ---
        setSelectedLocation(
          data.CurrentLocationId
            ? { value: data.CurrentLocationId, label: data.CurrentLocation }
            : null
        );

        // --- Check Frequency ---
        setSelectedCheckFreq(
          data.CheckupFrequency
            ? { value: data.CheckupFrequency, label: data.CheckupFrequency }
            : null
        );

        // --- Current Status ---
        if (data.CurrentStatus === "Active") setCurrentStatus(0);
        else if (data.CurrentStatus === "InActive") setCurrentStatus(1);
        else if (data.CurrentStatus === "Obsolute") setCurrentStatus(-1);
        else setCurrentStatus(0);

        // ✅ Project Name Fix
       // ✅ Project Name Fix — show only ProjectName when editing
if (data.ProjectName) {
  // find dropdown match using ProjectName only
  const foundOption = projectNameOptions.find(opt =>
    opt.label.toLowerCase().includes(data.ProjectName.toLowerCase())
  );

  if (foundOption) {
    // Show only ProjectName (not "Code - Name")
    setProjectName({
      value: foundOption.value,
      label: data.ProjectName,
    });
  } else {
    // fallback: just ProjectName text
    setProjectName({
      value: data.PrjId || 0,
      label: data.ProjectName,
    });
  }
} else {
  setProjectName(null);
}

      }
    } catch (err) {
      console.error("Error fetching edit data:", err);
    } finally {
      setIsEditLoading(false);
    }
  };

  fetchEditData();
}, [assetId, projectNameOptions]);


  // --- Save Handler ---
  const handleSave = async () => {
    try {
      const enteredAssetNo = assetNo.trim().toLowerCase();
      const listData = await api.getAssetRegisterList(userName);
      const assetList = listData?.Table || listData || [];
      const existingAssetNos = assetList.map(a => a.AssetNo?.trim().toLowerCase());
      const isDuplicate = existingAssetNos.includes(enteredAssetNo);

      if (isDuplicate && !assetId) {
        alert(`⚠️ Asset No "${assetNo}" already exists! Please use a different one.`);
        return;
      }

      const payload = {
        Sp_SqlAction: assetId ? "UPDATE" : "INSERT",
        AssetId: assetId || 0,
        AssetNo: assetNo,
        AssetName: assetName,
        SerialNo: serialNo,
        Model: model,
        EstRuning_Unit: estiRunUnit,
        Capacity_Unit: capacityUnit,
        Specification: specification,
        Manufacture: manufacturer,
        EstLIfe: estiLife,
        WCId: workCenter?.value || 0,
        WorkCenter: workCenter?.label || "",
        EPCGLicenseNo: epcgLicense,
        AccCode: acCode,
        OrginalPrize: originalSize,
        SupplierId: selectedSupplier?.value || 0,
        SupplierName: selectedSupplier?.label || "",
        InvNo: invoiceNo,
        InvDate: invDate,
        PoNo: poNo,
        PoDate: poDate,
        AssetMade: selectedAssetMade?.value || "",
        PurchasePrize: purchasePrice,
        CurrentValue: currentValue,
        AssetType: selectedAssetType?.value || "",
        AssetCondition: selectedAssetCondition?.value || "",
        DeptId: selectedDepartment?.value || 0,
        Department: selectedDepartment?.label || "",
        Ownership: selectedOwnership?.value || "",
        OwnById: selectedOwnBy?.value || 0,
        OwnBy: selectedOwnBy?.label || "",
        PrjId: projectName?.value || 0,
        ProjectName: projectName
          ? projectName.label.split(" - ").slice(-1)[0].trim()
          : "",
        CurrentLocationId: selectedLocation?.value || 0,
        CurrentLocation: selectedLocation?.label || "",
        CheckupFrequency: selectedCheckFreq?.value || "",
        AssetRating: rating,
        CurrentStatus: currentStatus,
        CalibirationLoc: " ",
        CalibrationBy: " ",
        CalibrationCheckupDate: new Date().toISOString().split("T")[0],
        CalibrationDueDate: new Date().toISOString().split("T")[0],
        Calibrationid: 0,
        CalibrationCode: " ",
        CalibrationStatus: 0,
        Notes: Notes,
        UserName: userName,
      };


      const res = await api.SaveBasicAssetRegister(payload);

      let savedAssetId = assetId;
      if (
        !assetId &&
        res?.SaveBasicAssetRegisterAPIjs?.Table &&
        res.SaveBasicAssetRegisterAPIjs.Table[0]?.Column1
      ) {
        savedAssetId = res.SaveBasicAssetRegisterAPIjs.Table[0].Column1;
      }

      if (savedAssetId) {
        sessionStorage.setItem("currentAssetId", savedAssetId);
        setAssetId(savedAssetId);
      }

      alert(assetId ? "✅ Asset updated successfully!" : "✅ Asset saved successfully!");
    } catch (err) {
      console.error(err);
      alert("❌ Error saving asset!");
    }
  };

  // --- Styles ---
  const inputStyle = {
    padding: "8px",
    borderRadius: "6px",
    border: "1px solid #d1d5db",
    fontSize: "14px",
    width: "100%",
    boxSizing: "border-box",
  };
  const labelStyle = { fontWeight: 600, fontSize: "14px", marginBottom: "4px" };
  const rowStyle = {
    display: "grid",
    gridTemplateColumns: "1.5fr 2fr 1.5fr 2fr",
    alignItems: "center",
    gap: "10px 20px",
    marginBottom: "8px",
  };
  const renderStars = () =>
    Array.from({ length: 5 }, (_, i) => (
      <span
        key={i}
        style={{
          cursor: "pointer",
          fontSize: "18px",
          color: i + 1 <= rating ? "#f59e0b" : "#d1d5db",
        }}
        onClick={() => setRating(i + 1)}
      >
        ★
      </span>
    ));

  return (
    <div
      style={{
        maxWidth: "1100px",
        margin: "0 auto",
        padding: "20px 30px",
        backgroundColor: "#f9fafb",
        borderRadius: "12px",
        boxShadow: "0 6px 25px rgba(0,0,0,0.08)",
      }}
    >
      <h2
        style={{
          fontSize: "22px",
          fontWeight: "700",
          textAlign: "center",
          marginBottom: "20px",
        }}
      >
        Basic Details
      </h2>

      {/* Asset Rows */}
      <div style={rowStyle}>
        <label style={labelStyle}>Asset No</label>
        <input
          type="text"
          value={assetNo}
          onChange={e => {
            const value = e.target.value;
            setAssetNo(value);

            if (!assetId) {
              const normalized = value.replace(/\s+/g, "").toLowerCase();
              const storedList =
                JSON.parse(sessionStorage.getItem("assetListForDupCheck")) || [];
              const duplicate = storedList.some(
                a => a.AssetNo?.replace(/\s+/g, "").toLowerCase() === normalized
              );
              if (duplicate) {
                alert(`⚠️ Asset No "${value}" already exists! Please use a different one.`);
              }
            }
          }}
          style={inputStyle}
          disabled={!!assetId}
        />

        <label style={labelStyle}>Ownership</label>
        <Select
          options={ownershipOptions}
          value={selectedOwnership}
          onChange={setSelectedOwnership}
          isClearable
          isSearchable
        />
      </div>

      {/* <div style={rowStyle}>
        <label style={labelStyle}>Project Name</label>
        <Select
          options={projectNameOptions}
          value={projectName}
          onChange={setProjectName}
          isClearable
          isSearchable
        />
      </div>

      <div style={rowStyle}>
        <label style={labelStyle}>Asset Name</label>
        <input type="text" value={assetName} onChange={(e) => setAssetName(e.target.value)} style={inputStyle} />
      </div> */}


<div style={rowStyle}>

    <label style={labelStyle}>Asset Name</label>
  <input
    type="text"
    value={assetName}
    onChange={(e) => setAssetName(e.target.value)}
    style={inputStyle}
  />
  
  <label style={labelStyle}>Project Name</label>
  <Select
    options={projectNameOptions}
    value={projectName}
    onChange={setProjectName}
    isClearable
    isSearchable
  />


</div>


      <div style={{ ...rowStyle, gridTemplateColumns: "0.8fr 3fr" }}>

        
        <label style={labelStyle}>Own By</label>
        <Select
          options={ownByOptions}
          value={selectedOwnBy}
          onChange={setSelectedOwnBy}
          isClearable
          isSearchable
          styles={{
            control: (base) => ({
              ...base,
              width: "65%",
              minHeight: "38px",
            }),
            menu: (base) => ({
              ...base,
              width: "100%",
            }),
          }}
        />
      </div>

      <div style={rowStyle}>
        <label style={labelStyle}>Serial No</label>
        <input type="text" value={serialNo} onChange={(e) => setSerialNo(e.target.value)} style={inputStyle} />
        <label></label>
        <div></div>
      </div>

      <div style={rowStyle}>
        <label style={labelStyle}>Model</label>
        <input type="text" value={model} onChange={(e) => setModel(e.target.value)} style={inputStyle} />
        <label></label>
        <div></div>
      </div>

      <div style={rowStyle}>
        <label style={labelStyle}>Esti. Run/Unit</label>
        <input type="number" value={estiRunUnit} onChange={(e) => setEstiRunUnit(e.target.value)} style={inputStyle} />
        <label style={labelStyle}>Capacity/Unit</label>
        <input type="text" value={capacityUnit} onChange={(e) => setCapacityUnit(e.target.value)} style={inputStyle} />
      </div>

      <div style={rowStyle}>
        <label style={labelStyle}>Specification</label>
        <textarea value={specification} onChange={(e) => setSpecification(e.target.value)} style={{ ...inputStyle, minHeight: "60px" }} />
        <label style={labelStyle}>Manufacturer</label>
        <input type="text" value={manufacturer} onChange={(e) => setManufacturer(e.target.value)} style={inputStyle} />
      </div>

      <div style={rowStyle}>
        <label style={labelStyle}>Asset Type</label>
        <Select options={assetData.map(i => ({ value: i.AssetType, label: i.AssetType }))}
          value={selectedAssetType}
          onChange={setSelectedAssetType}
          isClearable isSearchable />
        <label></label>
      </div>

      <div style={rowStyle}>
        <label style={labelStyle}>Asset Condition</label>
        <Select options={assetConditionOptions} value={selectedAssetCondition} onChange={setSelectedAssetCondition} isClearable isSearchable />
        <label style={labelStyle}>Esti. Life (Year)</label>
        <input type="number" value={estiLife} onChange={(e) => setEstiLife(e.target.value)} style={inputStyle} />
      </div>

      <div style={rowStyle}>
        <label style={labelStyle}>WorkCenter</label>
        <Select
          options={workCenterOptions}
          value={workCenter}
          onChange={setWorkCenter}
          isClearable
          isSearchable
        />
        <label style={labelStyle}>Department</label>
        <Select options={departmentOptions}
          value={selectedDepartment}
          onChange={setSelectedDepartment}
          isClearable
          isSearchable />
      </div>

      <div style={rowStyle}>
        <label style={labelStyle}>EPCG License No</label>
        <input type="text" value={epcgLicense} onChange={(e) => setEPCGLicense(e.target.value)} style={inputStyle} />
        <label style={labelStyle}>A/C Code</label>
        <input type="text" value={acCode} onChange={(e) => setACCode(e.target.value)} style={inputStyle} />
      </div>

      <div style={rowStyle}>
        <label style={labelStyle}>Original Size</label>
        <input type="number" value={originalSize} onChange={(e) => setOriginalSize(e.target.value)} style={inputStyle} />
        <label></label>
      </div>

      <div style={{ ...rowStyle, gridTemplateColumns: "0.8fr 3fr" }}>
        <label style={labelStyle}>Supplier Name</label>
        <Select
          options={supplierOptions}
          value={selectedSupplier}
          onChange={setSelectedSupplier}
          isClearable
          isSearchable
          styles={{
            control: (base) => ({
              ...base,
              width: "65%",
              minWidth: "500px",
              maxWidth: "700px",
            }),
            menu: (base) => ({
              ...base,
              width: "600px",
            }),
          }}
        />
      </div>

      <div style={rowStyle}>
        <label style={labelStyle}>Invoice No</label>
        <input type="text" value={invoiceNo} onChange={(e) => setInvoiceNo(e.target.value)} style={inputStyle} />
        <label style={labelStyle}>Inv Date</label>
        <input type="date" value={invDate} onChange={(e) => setInvDate(e.target.value)} style={inputStyle} />
      </div>

      <div style={rowStyle}>
        <label style={labelStyle}>PO No</label>
        <input type="text" value={poNo} onChange={(e) => setPoNo(e.target.value)} style={inputStyle} />
        <label style={labelStyle}>PO Date</label>
        <input type="date" value={poDate} onChange={(e) => setPoDate(e.target.value)} style={inputStyle} />
      </div>

      <div style={rowStyle}>
        <label style={labelStyle}>Asset Made</label>
        <Select options={assetMadeOptions} value={selectedAssetMade} onChange={setSelectedAssetMade} isClearable isSearchable />
        <label style={labelStyle}>Purchase Price</label>
        <input type="number" value={purchasePrice} onChange={(e) => setPurchasePrice(e.target.value)} style={inputStyle} />
      </div>

      <div style={rowStyle}>
        <label style={labelStyle}>Current Value</label>
        <input type="number" value={currentValue} onChange={(e) => setCurrentValue(e.target.value)} style={inputStyle} />
        <label style={labelStyle}>Checkup Frequency</label>
        <Select options={checkFreqOptions} value={selectedCheckFreq} onChange={setSelectedCheckFreq} isClearable isSearchable />
      </div>

      <div style={{ ...rowStyle, gridTemplateColumns: "0.8fr 3fr" }}>
        <label style={labelStyle}>Current Location</label>

        <div style={{ display: "flex", alignItems: "center", gap: "10px", width: "65%" }}>
          <Select
            options={locationOptions}
            value={selectedLocation}
            onChange={setSelectedLocation}
            isClearable
            isSearchable
            isDisabled={assetId && !isLocationEditable}  // 🔒 Disable for edit until "Edit" is clicked
            styles={{
              control: (base) => ({
                ...base,
                flex: 1,
                minWidth: "500px",
                maxWidth: "700px",
              }),
              menu: (base) => ({
                ...base,
                width: "600px",
              }),
            }}
          />

          {/* Show Edit button only when editing an existing asset */}
          {assetId && (
            <button
              type="button"
              onClick={() => setIsLocationEditable((prev) => !prev)}
              style={{
                backgroundColor: isLocationEditable ? "#ef4444" : "#3b82f6",
                color: "#fff",
                padding: "6px 12px",
                border: "none",
                borderRadius: "6px",
                cursor: "pointer",
                fontSize: "13px",
              }}
            >
              {isLocationEditable ? "Cancel" : "Edit"}
            </button>
          )}
        </div>
      </div>


      <div style={rowStyle}>
        <label style={labelStyle}>Current Status</label>
        <Select
          options={currentStatusOptions}
          value={
            currentStatusOptions.find(opt => {
              if (currentStatus === 0) return opt.value === "Active";
              if (currentStatus === 1) return opt.value === "InActive";
              if (currentStatus === -1) return opt.value === "Obsolute";
              return false;
            }) || null
          }
          onChange={(selected) => {
            let statusValue = 0; // default Active
            if (selected?.value === "Active") statusValue = 0;
            else if (selected?.value === "InActive") statusValue = 1;
            else if (selected?.value === "Obsolute") statusValue = -1;
            setCurrentStatus(statusValue);
          }}
          isClearable
          isSearchable
        />

        <label style={labelStyle}>Asset Rating</label>
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          {renderStars()}
        </div>
      </div>

      <div style={{ ...rowStyle, gridTemplateColumns: "0.8fr 3fr" }}>
        <label style={labelStyle}>Notes</label>
        <input type="text" value={Notes} onChange={(e) => setNotes(e.target.value)} style={inputStyle} />
      </div>

      {/* Save button */}
      <div style={{ textAlign: "right", marginTop: "20px", display: "flex", justifyContent: "flex-end", gap: "10px" }}>
  {/* ✅ Update Location button (only visible in edit mode and when editable) */}
  {assetId && isLocationEditable && (
    <button
      onClick={async () => {
        try {
          if (!selectedLocation) {
            alert("⚠️ Please select a location before updating!");
            return;
          }

          const response = await api.UpdateAssetLocationAPI(
            assetId,
            selectedLocation.value,
            selectedLocation.label
          );

          if (response) {
            alert("✅ Asset location updated successfully!");
            setIsLocationEditable(false);
          }
        } catch (error) {
          console.error("Error updating asset location:", error);
          alert("❌ Failed to update asset location!");
        }
      }}
      style={{
        backgroundColor: "#10b981",
        color: "#fff",
        padding: "10px 20px",
        borderRadius: "8px",
        border: "none",
        cursor: "pointer",
        fontSize: "14px",
      }}
    >
      Update Location
    </button>
  )}

  {/* Existing Save/Update button - untouched */}
  <button
    onClick={handleSave}
    style={{
      backgroundColor: "#3b82f6",
      color: "#fff",
      padding: "10px 25px",
      borderRadius: "8px",
      border: "none",
      cursor: "pointer",
      fontSize: "14px",
    }}
  >
    {assetId ? "Update" : "Save"}
  </button>
</div>


    </div>
  );
};

export default Basic;  



// import React, { useState, useEffect } from "react";
// import Select from "react-select";
// import api from "../../api/api";
// //import Calibration from "./Calibration";

// const Basic = ({ assetId, setAssetId }) => {
//   const currentDate = new Date().toISOString().split("T")[0];
//   const userName = sessionStorage.getItem("userName");

//   // --- Asset Info States ---
//   const [assetNo, setAssetNo] = useState("");
//   const [assetName, setAssetName] = useState("");
//   const [serialNo, setSerialNo] = useState("");
//   const [model, setModel] = useState("");
//   const [estiRunUnit, setEstiRunUnit] = useState(0);
//   const [capacityUnit, setCapacityUnit] = useState("");
//   const [specification, setSpecification] = useState("");
//   const [manufacturer, setManufacturer] = useState("");
//   const [estiLife, setEstiLife] = useState(0);
//   const [epcgLicense, setEPCGLicense] = useState("");
//   const [acCode, setACCode] = useState("");
//   const [originalSize, setOriginalSize] = useState(0);
//   const [invoiceNo, setInvoiceNo] = useState("");
//   const [Notes, setNotes] = useState("");

//   const [invDate, setInvDate] = useState(currentDate);
//   const [poNo, setPoNo] = useState("");
//   const [poDate, setPoDate] = useState(currentDate);
//   const [purchasePrice, setPurchasePrice] = useState(0);
//   const [currentValue, setCurrentValue] = useState(0);
//   const [isEditLoading, setIsEditLoading] = useState(false);

//   // --- Dropdown Options ---
//   const [assetData, setAssetData] = useState([]);
//   const [supplierOptions, setSupplierOptions] = useState([]);
//   const [assetMadeOptions, setAssetMadeOptions] = useState([]);
//   const [assetConditionOptions, setAssetConditionOptions] = useState([]);
//   const [checkFreqOptions, setCheckFreqOptions] = useState([]);
//   const [departmentOptions, setDepartmentOptions] = useState([]);
//   const [ownershipOptions, setOwnershipOptions] = useState([]);
//   const [ownByOptions, setOwnByOptions] = useState([]);
//   const [locationOptions, setLocationOptions] = useState([]);
//   const [workCenterOptions, setWorkCenterOptions] = useState([]);
//   const [projectNameOptions, setProjectNameOptions] = useState([]); // ✅ New dropdown options

//   // --- Selected Dropdown Values ---
//   const [selectedAssetType, setSelectedAssetType] = useState(null);
//   const [selectedSupplier, setSelectedSupplier] = useState(null);
//   const [selectedAssetMade, setSelectedAssetMade] = useState(null);
//   const [selectedAssetCondition, setSelectedAssetCondition] = useState(null);
//   const [selectedCheckFreq, setSelectedCheckFreq] = useState(null);
//   const [selectedDepartment, setSelectedDepartment] = useState(null);
//   const [selectedOwnership, setSelectedOwnership] = useState(null);
//   const [selectedOwnBy, setSelectedOwnBy] = useState(null);
//   const [selectedLocation, setSelectedLocation] = useState(null);
//   const [workCenter, setWorkCenter] = useState(null);
//   const [currentStatusOptions, setCurrentStatusOptions] = useState([]);
//   const [projectName, setProjectName] = useState(null); 

//   const [isLocationEditable, setIsLocationEditable] = useState(false);

//   const [rating, setRating] = useState(0);
//   const [currentStatus, setCurrentStatus] = useState(false);

//   useEffect(() => {
//     const fetchAssets = async () => {
//       try {
//         const data = await api.getAssetRegister(userName);

//         if (data?.Table)
//           setAssetData(data.Table);
//         if (data?.Table1)
//           setSupplierOptions(data.Table1.map(i => ({ value: i.Vid, label: i.Vname })));
//         if (data?.Table2)
//           setAssetMadeOptions(data.Table2.map(i => ({ value: i.ImportType, label: i.ImportType })));
//         if (data?.Table3)
//           setAssetConditionOptions(data.Table3.map(i => ({ value: i.AssetCondition, label: i.AssetCondition })));
//         if (data?.Table4)
//           setCheckFreqOptions(data.Table4.map(i => ({ value: i.CheckFrequency, label: i.CheckFrequency })));
//         if (data?.Table6)
//           setDepartmentOptions(data.Table6.map(i => ({ value: i.DeptId, label: i.Department })));
//         if (data?.Table12)
//           setOwnershipOptions(data.Table12.map(i => ({ value: i.Ownership, label: i.Ownership })));
//         if (data?.Table13)
//           setOwnByOptions(data.Table13.map(i => ({ value: i.OVid, label: i.OVname })));
//         if (data?.Table14)
//           setLocationOptions(data.Table14.map(i => ({ value: i.CLVid, label: i.CLVname })));
//         if (data?.Table16)
//           setWorkCenterOptions(data.Table16.map(i => ({ value: i.WcId, label: i.WorkCenter })));
//         if (data?.Table19)
//           setCurrentStatusOptions(data.Table19.map(i => ({ value: i.Status, label: i.Status })));

//         // ✅ New: Load Project Name dropdown
//         if (data?.Table21) {
//           setProjectNameOptions(
//             data.Table21.map(i => ({
//               value: i.PrjId,
//               label: `${i.ProjectCode} - ${i.ProjectName}`,
//             }))
//           );
//         }

//         const listData = await api.getAssetRegisterList(userName);
//         if (listData?.Table) {
//           sessionStorage.setItem("assetListForDupCheck", JSON.stringify(listData.Table));
//           console.log(
//             "✅ AssetNos loaded for duplicate check:",
//             listData.Table.map(a => a.AssetNo)
//           );
//         }
//       } catch (err) {
//         console.error("Error fetching asset register:", err);
//       }
//     };
//     fetchAssets();
//   }, [assetId]);

//   useEffect(() => {
//     if (isEditLoading) return;

//     const fetchOwnByOptions = async () => {
//       if (!selectedOwnership || selectedOwnership.value === "Own") {
//         setOwnByOptions([]);
//         setSelectedOwnBy(null);
//         return;
//       }

//       try {
//         const data = await api.getAssetRegister(userName, selectedOwnership.value);
//         if (data?.Table13) {
//           setOwnByOptions(data.Table13.map(i => ({ value: i.OVid, label: i.OVname })));
//         }
//       } catch (err) {
//         console.error("Error fetching OwnBy options:", err);
//       }
//     };

//     fetchOwnByOptions();
//   }, [selectedOwnership, isEditLoading]);

//   useEffect(() => {
//   if (!assetId) return;

//   const fetchEditData = async () => {
//     setIsEditLoading(true);
//     try {
//       const res = await api.EditBasicAssetRegister(assetId);
//       if (res && res.Table && res.Table[0]) {
//         const data = res.Table[0];

//         // Basic Fields
//         setAssetNo(data.AssetNo || "");
//         setAssetName(data.AssetName || "");
//         setSerialNo(data.SerialNo || "");
//         setModel(data.Model || "");
//         setEstiRunUnit(data.EstRuning_Unit || 0);
//         setCapacityUnit(data.Capacity_Unit || "");
//         setSpecification(data.Specification || "");
//         setManufacturer(data.Manufacture || "");
//         setEstiLife(data.EstLIfe || 0);
//         setEPCGLicense(data.EPCGLicenseNo || "");
//         setACCode(data.AccCode || "");
//         setOriginalSize(data.OrginalPrize || 0);
//         setInvoiceNo(data.InvNo || "");
//         setInvDate(data.InvDate?.split("T")[0] || currentDate);
//         setPoNo(data.PoNo || "");
//         setPoDate(data.PoDate?.split("T")[0] || currentDate);
//         setPurchasePrice(data.PurchasePrize || 0);
//         setCurrentValue(data.CurrentValue || 0);
//         setRating(data.AssetRating || 0);
//         setNotes(data.Notes || "");

//         // Dropdowns
//         setSelectedSupplier(
//           data.SupplierId ? { value: data.SupplierId, label: data.SupplierName } : null
//         );
//         setSelectedAssetType(
//           data.AssetType ? { value: data.AssetType, label: data.AssetType } : null
//         );
//         setSelectedAssetMade(
//           data.AssetMade ? { value: data.AssetMade, label: data.AssetMade } : null
//         );
//         setSelectedAssetCondition(
//           data.AssetCondition ? { value: data.AssetCondition, label: data.AssetCondition } : null
//         );
//         setSelectedDepartment(
//           data.DeptId ? { value: data.DeptId, label: data.Department } : null
//         );
//         setWorkCenter(
//           data.WcId ? { value: data.WcId, label: data.WorkCenter } : null
//         );

//         setSelectedOwnership(
//           data.Ownership ? { value: data.Ownership, label: data.Ownership } : null
//         );

//         // --- Own By ---
//         if (data.Ownership && data.Ownership !== "Own") {
//           try {
//             const ownByRes = await api.getAssetRegister(userName, data.Ownership);
//             if (ownByRes?.Table13) {
//               const options = ownByRes.Table13.map(i => ({
//                 value: i.OVid,
//                 label: i.OVname,
//               }));
//               setOwnByOptions(options);
//               const selectedOption =
//                 options.find(opt => opt.value == data.OwnById) ||
//                 { value: data.OwnById, label: data.OwnBy };
//               setSelectedOwnBy(selectedOption);
//             }
//           } catch (err) {
//             console.error("Error fetching OwnBy during edit:", err);
//           }
//         } else {
//           setOwnByOptions([]);
//           setSelectedOwnBy(null);
//         }

//         // --- Current Location ---
//         setSelectedLocation(
//           data.CurrentLocationId
//             ? { value: data.CurrentLocationId, label: data.CurrentLocation }
//             : null
//         );

//         // --- Check Frequency ---
//         setSelectedCheckFreq(
//           data.CheckupFrequency
//             ? { value: data.CheckupFrequency, label: data.CheckupFrequency }
//             : null
//         );

//         // --- Current Status ---
//         if (data.CurrentStatus === "Active") setCurrentStatus(0);
//         else if (data.CurrentStatus === "InActive") setCurrentStatus(1);
//         else if (data.CurrentStatus === "Obsolute") setCurrentStatus(-1);
//         else setCurrentStatus(0);

//         // ✅ Project Name Fix
//        // ✅ Project Name Fix — show only ProjectName when editing
// if (data.ProjectName) {
//   // find dropdown match using ProjectName only
//   const foundOption = projectNameOptions.find(opt =>
//     opt.label.toLowerCase().includes(data.ProjectName.toLowerCase())
//   );

//   if (foundOption) {
//     // Show only ProjectName (not "Code - Name")
//     setProjectName({
//       value: foundOption.value,
//       label: data.ProjectName,
//     });
//   } else {
//     // fallback: just ProjectName text
//     setProjectName({
//       value: data.PrjId || 0,
//       label: data.ProjectName,
//     });
//   }
// } else {
//   setProjectName(null);
// }

//       }
//     } catch (err) {
//       console.error("Error fetching edit data:", err);
//     } finally {
//       setIsEditLoading(false);
//     }
//   };

//   fetchEditData();
// }, [assetId, projectNameOptions]);


//   // --- Save Handler ---
//   const handleSave = async () => {
//     try {
//       const enteredAssetNo = assetNo.trim().toLowerCase();
//       const listData = await api.getAssetRegisterList(userName);
//       const assetList = listData?.Table || listData || [];
//       const existingAssetNos = assetList.map(a => a.AssetNo?.trim().toLowerCase());
//       const isDuplicate = existingAssetNos.includes(enteredAssetNo);

//       if (isDuplicate && !assetId) {
//         alert(`⚠️ Asset No "${assetNo}" already exists! Please use a different one.`);
//         return;
//       }

//       const payload = {
//         Sp_SqlAction: assetId ? "UPDATE" : "INSERT",
//         AssetId: assetId || 0,
//         AssetNo: assetNo,
//         AssetName: assetName,
//         SerialNo: serialNo,
//         Model: model,
//         EstRuning_Unit: estiRunUnit,
//         Capacity_Unit: capacityUnit,
//         Specification: specification,
//         Manufacture: manufacturer,
//         EstLIfe: estiLife,
//         WCId: workCenter?.value || 0,
//         WorkCenter: workCenter?.label || "",
//         EPCGLicenseNo: epcgLicense,
//         AccCode: acCode,
//         OrginalPrize: originalSize,
//         SupplierId: selectedSupplier?.value || 0,
//         SupplierName: selectedSupplier?.label || "",
//         InvNo: invoiceNo,
//         InvDate: invDate,
//         PoNo: poNo,
//         PoDate: poDate,
//         AssetMade: selectedAssetMade?.value || "",
//         PurchasePrize: purchasePrice,
//         CurrentValue: currentValue,
//         AssetType: selectedAssetType?.value || "",
//         AssetCondition: selectedAssetCondition?.value || "",
//         DeptId: selectedDepartment?.value || 0,
//         Department: selectedDepartment?.label || "",
//         Ownership: selectedOwnership?.value || "",
//         OwnById: selectedOwnBy?.value || 0,
//         OwnBy: selectedOwnBy?.label || "",
//         PrjId: projectName?.value || 0,
//         ProjectName: projectName
//           ? projectName.label.split(" - ").slice(-1)[0].trim()
//           : "",
//         CurrentLocationId: selectedLocation?.value || 0,
//         CurrentLocation: selectedLocation?.label || "",
//         CheckupFrequency: selectedCheckFreq?.value || "",
//         AssetRating: rating,
//         CurrentStatus: currentStatus,
//         CalibirationLoc: " ",
//         CalibrationBy: " ",
//         CalibrationCheckupDate: new Date().toISOString().split("T")[0],
//         CalibrationDueDate: new Date().toISOString().split("T")[0],
//         Calibrationid: 0,
//         CalibrationCode: " ",
//         CalibrationStatus: 0,
//         Notes: Notes,
//         UserName: userName,
//       };


//       const res = await api.SaveBasicAssetRegister(payload);

//       let savedAssetId = assetId;
//       if (
//         !assetId &&
//         res?.SaveBasicAssetRegisterAPIjs?.Table &&
//         res.SaveBasicAssetRegisterAPIjs.Table[0]?.Column1
//       ) {
//         savedAssetId = res.SaveBasicAssetRegisterAPIjs.Table[0].Column1;
//       }

//       if (savedAssetId) {
//         sessionStorage.setItem("currentAssetId", savedAssetId);
//         setAssetId(savedAssetId);
//       }

//       alert(assetId ? "✅ Asset updated successfully!" : "✅ Asset saved successfully!");
//     } catch (err) {
//       console.error(err);
//       alert("❌ Error saving asset!");
//     }
//   };

//   // --- Styles ---
//   const inputStyle = {
//     padding: "8px",
//     borderRadius: "6px",
//     border: "1px solid #d1d5db",
//     fontSize: "14px",
//     width: "100%",
//     boxSizing: "border-box",
//   };
//   const labelStyle = { fontWeight: 600, fontSize: "14px", marginBottom: "4px" };
//   const rowStyle = {
//     display: "grid",
//     gridTemplateColumns: "1.5fr 2fr 1.5fr 2fr",
//     alignItems: "center",
//     gap: "10px 20px",
//     marginBottom: "8px",
//   };
//   const renderStars = () =>
//     Array.from({ length: 5 }, (_, i) => (
//       <span
//         key={i}
//         style={{
//           cursor: "pointer",
//           fontSize: "18px",
//           color: i + 1 <= rating ? "#f59e0b" : "#d1d5db",
//         }}
//         onClick={() => setRating(i + 1)}
//       >
//         ★
//       </span>
//     ));

//   return (
//     <div
//       style={{
//         maxWidth: "1100px",
//         margin: "0 auto",
//         padding: "20px 30px",
//         backgroundColor: "#f9fafb",
//         borderRadius: "12px",
//         boxShadow: "0 6px 25px rgba(0,0,0,0.08)",
//       }}
//     >
//       <h2
//         style={{
//           fontSize: "22px",
//           fontWeight: "700",
//           textAlign: "center",
//           marginBottom: "20px",
//         }}
//       >
//         Basic Details
//       </h2>

//       {/* Asset Rows */}
//       <div style={rowStyle}>
//         <label style={labelStyle}>Asset No</label>
//         <input
//           type="text"
//           value={assetNo}
//           onChange={e => {
//             const value = e.target.value;
//             setAssetNo(value);

//             if (!assetId) {
//               const normalized = value.replace(/\s+/g, "").toLowerCase();
//               const storedList =
//                 JSON.parse(sessionStorage.getItem("assetListForDupCheck")) || [];
//               const duplicate = storedList.some(
//                 a => a.AssetNo?.replace(/\s+/g, "").toLowerCase() === normalized
//               );
//               if (duplicate) {
//                 alert(`⚠️ Asset No "${value}" already exists! Please use a different one.`);
//               }
//             }
//           }}
//           style={inputStyle}
//           disabled={!!assetId}
//         />

//         <label style={labelStyle}>Ownership</label>
//         <Select
//           options={ownershipOptions}
//           value={selectedOwnership}
//           onChange={setSelectedOwnership}
//           isClearable
//           isSearchable
//         />
//       </div>

//       {/* <div style={rowStyle}>
//         <label style={labelStyle}>Project Name</label>
//         <Select
//           options={projectNameOptions}
//           value={projectName}
//           onChange={setProjectName}
//           isClearable
//           isSearchable
//         />
//       </div>

//       <div style={rowStyle}>
//         <label style={labelStyle}>Asset Name</label>
//         <input type="text" value={assetName} onChange={(e) => setAssetName(e.target.value)} style={inputStyle} />
//       </div> */}


// <div style={rowStyle}>

//     <label style={labelStyle}>Asset Name</label>
//   <input
//     type="text"
//     value={assetName}
//     onChange={(e) => setAssetName(e.target.value)}
//     style={inputStyle}
//   />
  
//   <label style={labelStyle}>Project Name</label>
//   <Select
//     options={projectNameOptions}
//     value={projectName}
//     onChange={setProjectName}
//     isClearable
//     isSearchable
//   />


// </div>


//       <div style={{ ...rowStyle, gridTemplateColumns: "0.8fr 3fr" }}>

        
//         <label style={labelStyle}>Own By</label>
//         <Select
//           options={ownByOptions}
//           value={selectedOwnBy}
//           onChange={setSelectedOwnBy}
//           isClearable
//           isSearchable
//           styles={{
//             control: (base) => ({
//               ...base,
//               width: "65%",
//               minHeight: "38px",
//             }),
//             menu: (base) => ({
//               ...base,
//               width: "100%",
//             }),
//           }}
//         />
//       </div>

//       <div style={rowStyle}>
//         <label style={labelStyle}>Serial No</label>
//         <input type="text" value={serialNo} onChange={(e) => setSerialNo(e.target.value)} style={inputStyle} />
//         <label></label>
//         <div></div>
//       </div>

//       <div style={rowStyle}>
//         <label style={labelStyle}>Model</label>
//         <input type="text" value={model} onChange={(e) => setModel(e.target.value)} style={inputStyle} />
//         <label></label>
//         <div></div>
//       </div>

//       <div style={rowStyle}>
//         <label style={labelStyle}>Esti. Run/Unit</label>
//         <input type="number" value={estiRunUnit} onChange={(e) => setEstiRunUnit(e.target.value)} style={inputStyle} />
//         <label style={labelStyle}>Capacity/Unit</label>
//         <input type="text" value={capacityUnit} onChange={(e) => setCapacityUnit(e.target.value)} style={inputStyle} />
//       </div>

//       <div style={rowStyle}>
//         <label style={labelStyle}>Specification</label>
//         <textarea value={specification} onChange={(e) => setSpecification(e.target.value)} style={{ ...inputStyle, minHeight: "60px" }} />
//         <label style={labelStyle}>Manufacturer</label>
//         <input type="text" value={manufacturer} onChange={(e) => setManufacturer(e.target.value)} style={inputStyle} />
//       </div>

//       <div style={rowStyle}>
//         <label style={labelStyle}>Asset Type</label>
//         <Select options={assetData.map(i => ({ value: i.AssetType, label: i.AssetType }))}
//           value={selectedAssetType}
//           onChange={setSelectedAssetType}
//           isClearable isSearchable />
//         <label></label>
//       </div>

//       <div style={rowStyle}>
//         <label style={labelStyle}>Asset Condition</label>
//         <Select options={assetConditionOptions} value={selectedAssetCondition} onChange={setSelectedAssetCondition} isClearable isSearchable />
//         <label style={labelStyle}>Esti. Life (Year)</label>
//         <input type="number" value={estiLife} onChange={(e) => setEstiLife(e.target.value)} style={inputStyle} />
//       </div>

//       <div style={rowStyle}>
//         <label style={labelStyle}>WorkCenter</label>
//         <Select
//           options={workCenterOptions}
//           value={workCenter}
//           onChange={setWorkCenter}
//           isClearable
//           isSearchable
//         />
//         <label style={labelStyle}>Department</label>
//         <Select options={departmentOptions}
//           value={selectedDepartment}
//           onChange={setSelectedDepartment}
//           isClearable
//           isSearchable />
//       </div>

//       <div style={rowStyle}>
//         <label style={labelStyle}>EPCG License No</label>
//         <input type="text" value={epcgLicense} onChange={(e) => setEPCGLicense(e.target.value)} style={inputStyle} />
//         <label style={labelStyle}>A/C Code</label>
//         <input type="text" value={acCode} onChange={(e) => setACCode(e.target.value)} style={inputStyle} />
//       </div>

//       <div style={rowStyle}>
//         <label style={labelStyle}>Original Size</label>
//         <input type="number" value={originalSize} onChange={(e) => setOriginalSize(e.target.value)} style={inputStyle} />
//         <label></label>
//       </div>

//       <div style={{ ...rowStyle, gridTemplateColumns: "0.8fr 3fr" }}>
//         <label style={labelStyle}>Supplier Name</label>
//         <Select
//           options={supplierOptions}
//           value={selectedSupplier}
//           onChange={setSelectedSupplier}
//           isClearable
//           isSearchable
//           styles={{
//             control: (base) => ({
//               ...base,
//               width: "65%",
//               minWidth: "500px",
//               maxWidth: "700px",
//             }),
//             menu: (base) => ({
//               ...base,
//               width: "600px",
//             }),
//           }}
//         />
//       </div>

//       <div style={rowStyle}>
//         <label style={labelStyle}>Invoice No</label>
//         <input type="text" value={invoiceNo} onChange={(e) => setInvoiceNo(e.target.value)} style={inputStyle} />
//         <label style={labelStyle}>Inv Date</label>
//         <input type="date" value={invDate} onChange={(e) => setInvDate(e.target.value)} style={inputStyle} />
//       </div>

//       <div style={rowStyle}>
//         <label style={labelStyle}>PO No</label>
//         <input type="text" value={poNo} onChange={(e) => setPoNo(e.target.value)} style={inputStyle} />
//         <label style={labelStyle}>PO Date</label>
//         <input type="date" value={poDate} onChange={(e) => setPoDate(e.target.value)} style={inputStyle} />
//       </div>

//       <div style={rowStyle}>
//         <label style={labelStyle}>Asset Made</label>
//         <Select options={assetMadeOptions} value={selectedAssetMade} onChange={setSelectedAssetMade} isClearable isSearchable />
//         <label style={labelStyle}>Purchase Price</label>
//         <input type="number" value={purchasePrice} onChange={(e) => setPurchasePrice(e.target.value)} style={inputStyle} />
//       </div>

//       <div style={rowStyle}>
//         <label style={labelStyle}>Current Value</label>
//         <input type="number" value={currentValue} onChange={(e) => setCurrentValue(e.target.value)} style={inputStyle} />
//         <label style={labelStyle}>Checkup Frequency</label>
//         <Select options={checkFreqOptions} value={selectedCheckFreq} onChange={setSelectedCheckFreq} isClearable isSearchable />
//       </div>

//       <div style={{ ...rowStyle, gridTemplateColumns: "0.8fr 3fr" }}>
//         <label style={labelStyle}>Current Location</label>

//         <div style={{ display: "flex", alignItems: "center", gap: "10px", width: "65%" }}>
//           <Select
//             options={locationOptions}
//             value={selectedLocation}
//             onChange={setSelectedLocation}
//             isClearable
//             isSearchable
//             isDisabled={assetId && !isLocationEditable}  // 🔒 Disable for edit until "Edit" is clicked
//             styles={{
//               control: (base) => ({
//                 ...base,
//                 flex: 1,
//                 minWidth: "500px",
//                 maxWidth: "700px",
//               }),
//               menu: (base) => ({
//                 ...base,
//                 width: "600px",
//               }),
//             }}
//           />

//           {/* Show Edit button only when editing an existing asset */}
//           {assetId && (
//             <button
//               type="button"
//               onClick={() => setIsLocationEditable((prev) => !prev)}
//               style={{
//                 backgroundColor: isLocationEditable ? "#ef4444" : "#3b82f6",
//                 color: "#fff",
//                 padding: "6px 12px",
//                 border: "none",
//                 borderRadius: "6px",
//                 cursor: "pointer",
//                 fontSize: "13px",
//               }}
//             >
//               {isLocationEditable ? "Cancel" : "Edit"}
//             </button>
//           )}
//         </div>
//       </div>


//       <div style={rowStyle}>
//         <label style={labelStyle}>Current Status</label>
//         <Select
//           options={currentStatusOptions}
//           value={
//             currentStatusOptions.find(opt => {
//               if (currentStatus === 0) return opt.value === "Active";
//               if (currentStatus === 1) return opt.value === "InActive";
//               if (currentStatus === -1) return opt.value === "Obsolute";
//               return false;
//             }) || null
//           }
//           onChange={(selected) => {
//             let statusValue = 0; // default Active
//             if (selected?.value === "Active") statusValue = 0;
//             else if (selected?.value === "InActive") statusValue = 1;
//             else if (selected?.value === "Obsolute") statusValue = -1;
//             setCurrentStatus(statusValue);
//           }}
//           isClearable
//           isSearchable
//         />

//         <label style={labelStyle}>Asset Rating</label>
//         <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
//           {renderStars()}
//         </div>
//       </div>

//       <div style={{ ...rowStyle, gridTemplateColumns: "0.8fr 3fr" }}>
//         <label style={labelStyle}>Notes</label>
//         <input type="text" value={Notes} onChange={(e) => setNotes(e.target.value)} style={inputStyle} />
//       </div>

//       {/* Save button */}
//       <div style={{ textAlign: "right", marginTop: "20px" }}>
//         <button
//           onClick={handleSave}
//           style={{
//             backgroundColor: "#3b82f6",
//             color: "#fff",
//             padding: "10px 25px",
//             borderRadius: "8px",
//             border: "none",
//             cursor: "pointer",
//           }}
//         >
//           {assetId ? "Update" : "Save"}
//         </button>
//       </div>

//     </div>
//   );
// };

// export default Basic;  
 